<template>
  <Colaboracoes v-if="isMidiasModeracao" />
  <Noticias v-else-if="$store.state.moderacao.modoModeracao == 1" />
  <Enquetes v-else-if="$store.state.moderacao.modoModeracao == 2" />
  <Cameras v-else-if="$store.state.moderacao.modoModeracao == 3" />
  <Cronometro v-else />
</template>

<script>
import Colaboracoes from "./Colaboracoes.vue";
import Noticias from "./Noticias.vue";
import Enquetes from "./Enquetes.vue";
import Cronometro from "./Cronometro.vue";
import Cameras from "./Cameras.vue";

export default {
  name: "ModeracaoView",
  components: {
    Colaboracoes,
    Noticias,
    Enquetes,
    Cameras,
    Cronometro,
  },
  data() {
    return {
      isMidiasModeracao:
        !this.$store.state.moderacao.modoModeracao ||
        this.$store.state.moderacao.modoModeracao == 0,
    };
  },
  watch: {
    "$store.state.moderacao.modoModeracao": function (newValue) {
      this.isMidiasModeracao = !newValue || newValue == 0;
    },
  },
};
</script>
